import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Icon, Popup } from "semantic-ui-react";
import styled from "styled-components";
import GradientText from "../GradientText/GradientText";
import InfoIcon from "../icons/InfoIcon";
import parse from "html-react-parser";

const InputGradientext: React.FunctionComponent<{
  name: string;
  handleChange: (any: any, name?: string) => void;
  placeholder?: string;
  propValues?: any;
  errorMessage?: string | undefined | boolean;
  label?: string;
  defaultValue?: string;
  value?: any;
  gradientLabel?: string;
  handleBlur?: () => void;
  handleFocus?: () => void;
  handleOnInput?: (e: any) => void;
  toolTip?: any;
  toolTipHeader?: string;
  maxLength?: number;
  errorComponent?: any;
  prefix?: any;
  gradientFontSize?: string;
  hideline?: any;
  disabled?: boolean;
  testid?: string;
}> = ({
  name,
  handleChange,
  placeholder,
  propValues,
  errorMessage,
  label,
  defaultValue,
  value,
  gradientLabel,
  handleBlur,
  handleFocus,
  handleOnInput,
  toolTip,
  toolTipHeader,
  maxLength,
  errorComponent,
  prefix,
  gradientFontSize = "1.75rem",
  hideline = false,
  disabled = false,
  testid,
}) => {
  const defaultPrimary = "#606ac1";
  const defaultSecondary = "#e300b1";
  const [whiteLabel] = useSelector((state) => [
    state.authReducer.preAuthDetails.whiteLabel,
  ]);

  return (
    <StyledGradientWrapper
      data-testid={testid || "gradient-text-input"}
      style={propValues?.containerStyles && { ...propValues.containerStyles }}
    >
      {label && <StyledLabel>{label}</StyledLabel>}
      {gradientLabel && (
        <StyledLabelContainer>
          <GradientText string={gradientLabel} fontSize={gradientFontSize} />
          {toolTip && (
            <Popup
              content={toolTip}
              key={"user.name"}
              header={toolTipHeader && toolTipHeader}
              trigger={
                <StyledToolTipContainer>
                  <InfoIcon />
                </StyledToolTipContainer>
              }
            />
          )}
        </StyledLabelContainer>
      )}
      <StyledGradientTextInput
        {...propValues}
        name={name}
        onChange={(e) => !disabled && handleChange(e)}
        placeholder={placeholder || label || gradientLabel}
        primaryColor={whiteLabel?.primarycolor ?? defaultPrimary}
        secondaryColor={whiteLabel?.secondarycolor ?? defaultSecondary}
        autoComplete={"new-password"}
        style={{ ...propValues?.styles }}
        value={value}
        onBlur={() => handleBlur && handleBlur()}
        onFocus={() => handleFocus && handleFocus()}
        onInput={(e) => handleOnInput && handleOnInput(e)}
        data-testid={`${testid ? testid : name}-input`}
        maxLength={maxLength}
        prefix={prefix}
      />
      {!hideline && (
        <GradientLine
          primaryColor={whiteLabel?.primarycolor ?? defaultPrimary}
          secondaryColor={whiteLabel?.secondarycolor ?? defaultSecondary}
        ></GradientLine>
      )}
      {errorMessage && (
        <ErrorMessage data-testid={"errorMessage"}>
          {parse(errorMessage)}
        </ErrorMessage>
      )}
    </StyledGradientWrapper>
  );
};

interface ICSProps {
  primaryColor: string;
  secondaryColor: string;
}

const StyledGradientWrapper = styled.div<ICSProps>`
  margin: 1.5rem 0;
  position: relative;
  width: 100%;
`;

const StyledLabel = styled.h2<ICSProps>`
  font-size: 1.25rem;
  font-family: Montserrat;
  margin-top: 1rem;
  color: #6673a5;
  font-weight: 400;
`;

const StyledGradientTextInput = styled.input<ICSProps>`
  border: 0;
  border-bottom: 1px solid transparent;
  padding-bottom: 0.5rem;
  width: 100%;
  color: #6673a5;
  font-size: 1.25rem;
  font-family: Montserrat;
  letter-spacing: 1.25px;

  &:focus {
    outline: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

const GradientLine = styled.div<ICSProps>`
  height: 3px;
  color: white;
  background: linear-gradient(
    to right,
    ${(props) => props.primaryColor},
    ${(props) => props.secondaryColor} 50% 0
  );
  position: absolute;
  width: 100%;
`;

const ErrorMessage = styled.div<ICSProps>`
  font-size: 1.25rem;
  font-family: Montserrat;
  font-weight: 400;
  margin-top: 1rem;
  color: red;
`;

const StyledLabelContainer = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const StyledToolTipContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.75rem;
  cursor: pointer;
`;

export default InputGradientext;
